export { default } from './FormattedDate.js';



// WEBPACK FOOTER //
// ./src/public/components/View/FormattedDate/index.js